// FWSD-7690
const correctValueVideoChannelQuality = (argValue) => {
	return +argValue + 1
}

// If configuration setting value is enough for displaying then we set config node to "setting" object key.
// If value of "setting" object key is true/false then we convert it to ON/OFF. But if value 1/0 and we want display ON/OFF then we set the "type" object key = boolean.
// If "setting" key is empty then we use separate functions to display the value of each setting in the getSettingValue function
// last id = 354
export const profileSettings = {
	dv6: {
		general: [
			{ id: 1, name: 'ADAS Audio Alert', setting: 'System.Chimes.Adas', depreciated: true },
			{ id: 2, name: 'Camera Event Chime', setting: 'Event.BuzzerEnabled' },
			{ id: 3, name: 'DMS Alert Voice', setting: 'System.Chimes.Dms', depreciated: true },
			{ id: 4, name: 'Event Chime Volume', setting: 'System.Chimes.Volume' },
			{ id: 145, name: 'Power Off Audio', setting: 'System.Chimes.PowerOn' },
			{ id: 5, name: 'Overlay Speed on Video', setting: 'Overlay.ShowSpeed' },
			{ id: 6, name: 'Parking Duration', setting: 'General.IgnitionShutdownDelay' },
			// {id:143, name: 'Ignition Switch Only', setting: 'General.IgnitionSwitchOnly', type: 'boolean'},
			{ id: 7, name: 'Parking Mode', setting: '' },
			{ id: 10, name: 'Speed Unit', setting: '' },
			{ id: 11, name: 'Timezone', setting: 'General.TimeZone' },
			{ id: 114, name: 'Display Timezone in Video', setting: 'Overlay.ShowTZ', type: 'boolean' },
			{ id: 113, name: 'Wake-up/Sleep Mode', setting: 'Servers.SleepMode.Enabled' },
		],
		video: [
			{ id: 12, name: 'Channel 1', setting: 'Channels.0.Enabled' },
			// {id:13, name: 'Channel 1 Recording', setting: ''},
			{ id: 115, name: 'Channel 1 Recording FPS', setting: 'Channels.0.MainFPS' },
			{ id: 116, name: 'Channel 1 Recording Quality', setting: 'Channels.0.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 117, name: 'Channel 1 Parking Mode FPS', setting: 'Channels.0.ParkingFPS' },
			{ id: 118, name: 'Channel 1 Parking Mode Quality', setting: 'Channels.0.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 14, name: 'Channel 2', setting: 'Channels.1.Enabled' },
			{ id: 15, name: 'Channel 2 Audio', setting: 'Channels.1.Audio', type: 'boolean' },
			// {id:16, name: 'Channel 2 Recording', setting: ''},
			{ id: 119, name: 'Channel 2 Recording FPS', setting: 'Channels.1.MainFPS' },
			{ id: 120, name: 'Channel 2 Recording Quality', setting: 'Channels.1.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 121, name: 'Channel 2 Parking Mode FPS', setting: 'Channels.1.ParkingFPS' },
			{ id: 122, name: 'Channel 2 Parking Mode Quality', setting: 'Channels.1.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 17, name: 'Channel 3', setting: 'Channels.2.Enabled' },
			{ id: 18, name: 'Channel 3 Audio', setting: 'Channels.2.Audio', type: 'boolean' },
			// {id:19, name: 'Channel 3 Recording', setting: ''},
			{ id: 123, name: 'Channel 3 Recording FPS', setting: 'Channels.2.MainFPS' },
			{ id: 124, name: 'Channel 3 Recording Quality', setting: 'Channels.2.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 125, name: 'Channel 3 Parking Mode FPS', setting: 'Channels.2.ParkingFPS' },
			{ id: 126, name: 'Channel 3 Parking Mode Quality', setting: 'Channels.2.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 147, name: 'Channel 4', setting: 'Channels.3.Enabled' },
			{ id: 148, name: 'Channel 4 Audio', setting: 'Channels.3.Audio', type: 'boolean' },
			{ id: 149, name: 'Channel 4 Recording FPS', setting: 'Channels.3.MainFPS' },
			{ id: 150, name: 'Channel 4 Recording Quality', setting: 'Channels.3.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 151, name: 'Channel 4 Parking Mode FPS', setting: 'Channels.3.ParkingFPS' },
			{ id: 152, name: 'Channel 4 Parking Mode Quality', setting: 'Channels.3.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },
		],
		event: [
			{ id: 20, name: 'ADAS - Forward Collision', setting: 'Event.Adas.ForwardCollision.Enabled' },
			{ id: 21, name: 'ADAS - Forward Collision Upload Type', setting: '' },
			{ id: 110, name: 'ADAS - Forward Collision Event Audio', setting: 'System.Chimes.ForwardCollision' },
			{ id: 22, name: 'ADAS - Headway Monitoring', setting: 'Event.Adas.Headway.Enabled' },
			{ id: 23, name: 'ADAS - Headway Monitoring Upload Type', setting: '' },
			{ id: 111, name: 'ADAS - Headway Monitoring Event Audio', setting: 'System.Chimes.Headway' },
			{ id: 24, name: 'ADAS - Tailgating', setting: 'Event.Adas.FollowingDistance.Enabled' },
			{ id: 25, name: 'ADAS - Tailgating Upload Type', setting: '' },
			{ id: 112, name: 'ADAS - Tailgating Event Audio', setting: 'System.Chimes.FollowingDistance' },
			{ id: 26, name: 'ADAS - Minimum Speed', setting: '' },
			{ id: 27, name: 'ADAS - Following Distance Time', setting: 'Event.Adas.Headway.Ttc.TriggerThreshold' },
			{ id: 28, name: 'DMS - Distraction', setting: 'Event.Dms.Distraction.Enabled' },
			{ id: 29, name: 'DMS - Distraction Upload Type', setting: '' },
			{ id: 93, name: 'DMS - Distraction Sensitivity', setting: '' },
			{ id: 109, name: 'DMS - Distraction Event Audio', setting: 'System.Chimes.Distraction' },
			{ id: 331, name: 'DMS - Distraction Minimum Speed', setting: 'Event.Dms.Distraction.SpeedThreshold' },
			{ id: 30, name: 'DMS - Yawning', setting: 'Event.Dms.Yawning.Enabled' },
			{ id: 31, name: 'DMS - Yawning Upload Type', setting: '' },
			{ id: 32, name: 'DMS - Yawning Sensitivity', setting: '' },
			{ id: 108, name: 'DMS - Yawning Event Voice Prompt', setting: 'System.Chimes.Yawning' },
			{ id: 332, name: 'DMS - Yawning Minimum Speed', setting: 'Event.Dms.Yawning.SpeedThreshold' },
			{ id: 33, name: 'DMS - Dozing', setting: 'Event.Dms.Dozing.Enabled' },
			{ id: 34, name: 'DMS - Dozing Upload Type', setting: '' },
			{ id: 35, name: 'DMS - Dozing Sensitivity', setting: '' },
			{ id: 107, name: 'DMS - Dozing Event Voice Prompt', setting: 'System.Chimes.Drowsiness' },
			{ id: 333, name: 'DMS - Dozing Minimum Speed', setting: 'Event.Dms.Dozing.SpeedThreshold' },
			{ id: 36, name: 'DMS - Phone Use', setting: 'Event.Dms.PhoneUse.Enabled' },
			{ id: 37, name: 'DMS - Phone Use Upload Type', setting: '' },
			{ id: 38, name: 'DMS - Phone Use Sensitivity', setting: '' },
			{ id: 106, name: 'DMS - Phone Use Voice Prompt', setting: 'System.Chimes.PhoneUse' },
			{ id: 334, name: 'DMS - Phone Use Minimum Speed', setting: 'Event.Dms.PhoneUse.SpeedThreshold' },
			{ id: 94, name: 'DMS - Smoking', setting: 'Event.Dms.Smoking.Enabled' },
			{ id: 95, name: 'DMS - Smoking Upload Type', setting: '' },
			{ id: 96, name: 'DMS - Smoking Sensitivity', setting: '' },
			{ id: 97, name: 'DMS - Smoking Event Voice Prompt', setting: 'System.Chimes.Smoking' },
			{ id: 335, name: 'DMS - Smoking Minimum Speed', setting: 'Event.Dms.Smoking.SpeedThreshold' },
			// {id:98, name: 'DMS - Seatbelt', setting: 'Event.Dms.Seatbelt.Enabled', isInternal: true},
			{ id: 98, name: 'DMS - Seatbelt', setting: 'Event.Dms.Seatbelt.Enabled' },
			{ id: 99, name: 'DMS - Seatbelt Upload Type', setting: '' },
			{ id: 100, name: 'DMS - Seatbelt Sensitivity', setting: '' },
			{ id: 101, name: 'DMS - Seatbelt Event Audio', setting: 'System.Chimes.Seatbelt' },
			{ id: 336, name: 'DMS - Seatbelt Minimum Speed', setting: 'Event.Dms.Seatbelt.SpeedThreshold' },
			{ id: 8, name: 'Potential Ch2 Obstruction Detection', setting: 'Event.Dms.CameraObstruction.Enabled' },
			{ id: 9, name: 'Potential Ch2 Obstruction Detection Voice Prompt', setting: '' },
			{ id: 114, name: 'Potential Ch2 Obstruction Upload Type', setting: '' },
			{ id: 146, name: 'Potential Ch2 Obstruction Detection Event Audio', setting: 'System.Chimes.CameraObstruction.SoundType' },
			{ id: 337, name: 'Potential Ch2 Obstruction Detection Minimum Speed', setting: 'Event.Dms.CameraObstruction.SpeedThreshold' },
			{ id: 39, name: 'Driver Event', setting: 'Event.Sensor.4.Enabled' },
			{ id: 40, name: 'Driver Event Upload Type', setting: '' },
			{ id: 41, name: 'Harsh Acceleration', setting: 'Event.HarshAccel.Enabled' },
			{ id: 42, name: 'Harsh Acceleration Upload Type', setting: '' },
			// {id:43, name: 'Harsh Acceleration Sensitivity', setting: 'Event.HarshAccel.Threshold'},
			{ id: 43, name: 'Harsh Acceleration Sensitivity', setting: '' },
			{ id: 104, name: 'Harsh Acceleration Event Audio', setting: 'System.Chimes.HarshAccel' },
			{ id: 44, name: 'Harsh Braking', setting: 'Event.HarshBraking.Enabled' },
			{ id: 45, name: 'Harsh Braking Upload Type', setting: '' },
			// {id:46, name: 'Harsh Braking Sensitivity', setting: 'Event.HarshBraking.Threshold'},
			{ id: 46, name: 'Harsh Braking Sensitivity', setting: '' },
			{ id: 103, name: 'Harsh Braking Event Audio', setting: 'System.Chimes.HarshBraking' },
			{ id: 47, name: 'High G-Force', setting: 'Event.Accelerometer.Enabled' },
			{ id: 48, name: 'High G-Force Upload Type', setting: '' },
			{ id: 49, name: 'High G-Force Sensitivity', setting: 'Event.Accelerometer.FatalThreshold.X' },
			{ id: 353, name: 'High G-Force Parking Sensitivity', setting: 'Event.Accelerometer.ParkingThreshold.X' },
			{ id: 102, name: 'High G-Force Event Chime', setting: 'System.Chimes.Accelerometer' },
			{ id: 50, name: 'Max Speed', setting: 'Event.HighSpeed.Enabled' },
			{ id: 51, name: 'Max Speed Upload Type', setting: '' },
			{ id: 52, name: 'Max Speed Threshold', setting: '' },
			{ id: 105, name: 'Max Speed Event Chime', setting: 'System.Chimes.HighSpeed' },
		],
	},
	dv7: {
		general: [
			{ id: 188, name: 'ADAS Audio Alert', setting: 'System.Chimes.Adas', depreciated: true },
			{ id: 189, name: 'Camera Event Chime', setting: 'Event.BuzzerEnabled' },
			{ id: 190, name: 'DMS Alert Voice', setting: 'System.Chimes.Dms', depreciated: true },
			{ id: 191, name: 'Event Chime Volume', setting: 'System.Chimes.Volume' },
			{ id: 192, name: 'Power Off Audio', setting: 'System.Chimes.PowerOn' },
			{ id: 193, name: 'Overlay Speed on Video', setting: 'Overlay.ShowSpeed' },
			{ id: 194, name: 'Parking Duration', setting: 'General.IgnitionShutdownDelay' },
			// {id: 195, name: 'Ignition Switch Only', setting: 'General.IgnitionSwitchOnly', type: 'boolean'},
			{ id: 196, name: 'Parking Mode', setting: '' },
			{ id: 197, name: 'Speed Unit', setting: '' },
			{ id: 198, name: 'Timezone', setting: 'General.TimeZone' },
			{ id: 199, name: 'Display Timezone in Video', setting: 'Overlay.ShowTZ', type: 'boolean' },
			{ id: 200, name: 'Wake-up/Sleep Mode', setting: 'Servers.SleepMode.Enabled' },
		],
		video: [
			{ id: 201, name: 'Channel 1', setting: 'Channels.0.Enabled' },
			// {id: 202, name: 'Channel 1 Recording', setting: ''},
			{ id: 203, name: 'Channel 1 Recording FPS', setting: 'Channels.0.MainFPS' },
			{ id: 204, name: 'Channel 1 Recording Quality', setting: 'Channels.0.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 205, name: 'Channel 1 Parking Mode FPS', setting: 'Channels.0.ParkingFPS' },
			{ id: 206, name: 'Channel 1 Parking Mode Quality', setting: 'Channels.0.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 207, name: 'Channel 2', setting: 'Channels.1.Enabled' },
			{ id: 208, name: 'Channel 2 Audio', setting: 'Channels.1.Audio', type: 'boolean' },
			// {id: 209, name: 'Channel 2 Recording', setting: ''},
			{ id: 210, name: 'Channel 2 Recording FPS', setting: 'Channels.1.MainFPS' },
			{ id: 211, name: 'Channel 2 Recording Quality', setting: 'Channels.1.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 212, name: 'Channel 2 Parking Mode FPS', setting: 'Channels.1.ParkingFPS' },
			{ id: 213, name: 'Channel 2 Parking Mode Quality', setting: 'Channels.1.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 214, name: 'Channel 3', setting: 'Channels.2.Enabled' },
			{ id: 215, name: 'Channel 3 Audio', setting: 'Channels.2.Audio', type: 'boolean' },
			// {id: 216, name: 'Channel 3 Recording', setting: ''},
			{ id: 217, name: 'Channel 3 Recording FPS', setting: 'Channels.2.MainFPS' },
			{ id: 218, name: 'Channel 3 Recording Quality', setting: 'Channels.2.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 219, name: 'Channel 3 Parking Mode FPS', setting: 'Channels.2.ParkingFPS' },
			{ id: 220, name: 'Channel 3 Parking Mode Quality', setting: 'Channels.2.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 221, name: 'Channel 4', setting: 'Channels.3.Enabled' },
			{ id: 222, name: 'Channel 4 Audio', setting: 'Channels.3.Audio', type: 'boolean' },
			{ id: 223, name: 'Channel 4 Recording FPS', setting: 'Channels.3.MainFPS' },
			{ id: 224, name: 'Channel 4 Recording Quality', setting: 'Channels.3.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 225, name: 'Channel 4 Parking Mode FPS', setting: 'Channels.3.ParkingFPS' },
			{ id: 226, name: 'Channel 4 Parking Mode Quality', setting: 'Channels.3.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },
		],
		event: [
			{ id: 227, name: 'ADAS - Forward Collision', setting: 'Event.Adas.ForwardCollision.Enabled' },
			{ id: 228, name: 'ADAS - Forward Collision Upload Type', setting: '' },
			{ id: 229, name: 'ADAS - Forward Collision Event Audio', setting: 'System.Chimes.ForwardCollision' },
			{ id: 230, name: 'ADAS - Front Vehicle Start Alert', setting: 'Event.Adas.FrontVehicleStart.Enabled' },
			{ id: 231, name: 'ADAS - Front Vehicle Start Alert Upload Type', setting: '' },
			{ id: 232, name: 'ADAS - Front Vehicle Start Alert Event Audio', setting: 'System.Chimes.FrontVehicleStart' },
			{ id: 323, name: 'ADAS - Front Vehicle Start Alert Sensitivity', setting: 'Event.Adas.FrontVehicleStart.Sensitivity' },
			{ id: 233, name: 'ADAS - Traffic Light Compliance Warning', setting: 'Event.Adas.TrafficLightViolation.Enabled' },
			{ id: 234, name: 'ADAS - Traffic Light Compliance Warning Upload Type', setting: '' },
			{ id: 235, name: 'ADAS - Traffic Light Compliance Warning Signal Approach Warning', setting: 'System.Chimes.TrafficLightViolation.1' },
			{ id: 326, name: 'ADAS - Traffic Light Compliance Warning Signal Violation Warning', setting: 'System.Chimes.TrafficLightViolation.2' },
			{ id: 327, name: 'ADAS - Traffic Light Compliance Warning Minimum Speed', setting: 'Event.Adas.TrafficLightViolation.SpeedThreshold' },
			{ id: 236, name: 'ADAS - Traffic Light Compliance Warning Sensitivity', setting: 'Event.Adas.TrafficLightViolation.Sensitivity' },
			{ id: 237, name: 'ADAS - Headway Monitoring', setting: 'Event.Adas.Headway.Enabled' },
			{ id: 238, name: 'ADAS - Headway Monitoring Upload Type', setting: '' },
			{ id: 239, name: 'ADAS - Headway Monitoring Event Audio', setting: 'System.Chimes.Headway' },
			{ id: 240, name: 'ADAS - Stop Sign Compliance Warning', setting: 'Event.Adas.StopSignViolation.Enabled' },
			{ id: 241, name: 'ADAS - Stop Sign Compliance Warning Upload Type', setting: '' },
			{ id: 242, name: 'ADAS - Stop Sign Compliance Warning Rolling Stop', setting: 'System.Chimes.StopSignViolation.1' },
			{ id: 328, name: 'ADAS - Stop Sign Compliance Warning Bypass Stop', setting: 'System.Chimes.StopSignViolation.2' },
			{ id: 329, name: 'ADAS - Stop Sign Compliance Warning Minimum Speed', setting: 'Event.Adas.StopSignViolation.MaxStopSpeed' },
			{ id: 243, name: 'ADAS - Stop Sign Compliance Warning Sensitivity', setting: 'Event.Adas.StopSignViolation.Sensitivity' },
			{ id: 244, name: 'ADAS - Tailgating', setting: 'Event.Adas.FollowingDistance.Enabled' },
			{ id: 245, name: 'ADAS - Tailgating Upload Type', setting: '' },
			{ id: 246, name: 'ADAS - Tailgating Event Audio', setting: 'System.Chimes.FollowingDistance' },
			{ id: 247, name: 'ADAS - Minimum Speed', setting: '' },
			{ id: 248, name: 'ADAS - Following Distance Time', setting: 'Event.Adas.Headway.Ttc.TriggerThreshold' },
			{ id: 345, name: 'ADAS - Pedestrian Collision Warning', setting: 'Event.Adas.PedestrianWarning.Enabled' },
			{ id: 346, name: 'ADAS - Pedestrian Collision Warning Upload Type', setting: '' },
			{ id: 347, name: 'ADAS - Pedestrian Collision Warning Event Audio', setting: 'System.Chimes.PedestrianWarning' },
			{ id: 348, name: 'ADAS - Pedestrian Collision Warning Sensitivity', setting: 'Event.Adas.PedestrianWarning.Sensitivity' },
			{ id: 349, name: 'ADAS - Lane Departure Warning', setting: 'Event.Adas.LaneDeparture.Enabled' },
			{ id: 350, name: 'ADAS - Lane Departure Warning Upload Type', setting: '' },
			{ id: 351, name: 'ADAS - Lane Departure Warning Event Chime', setting: 'System.Chimes.LaneDeparture', type: 'boolean' },
			{ id: 352, name: 'ADAS - Lane Departure Warning Minimum Speed', setting: 'Event.Adas.LaneDeparture.SpeedThreshold' },
			{ id: 249, name: 'DMS - Distraction', setting: 'Event.Dms.Distraction.Enabled' },
			{ id: 250, name: 'DMS - Distraction Upload Type', setting: '' },
			{ id: 251, name: 'DMS - Distraction Sensitivity', setting: '' },
			{ id: 252, name: 'DMS - Distraction Event Audio', setting: 'System.Chimes.Distraction' },
			{ id: 338, name: 'DMS - Distraction Minimum Speed', setting: 'Event.Dms.Distraction.SpeedThreshold' },
			{ id: 253, name: 'DMS - Yawning', setting: 'Event.Dms.Yawning.Enabled' },
			{ id: 254, name: 'DMS - Yawning Upload Type', setting: '' },
			{ id: 255, name: 'DMS - Yawning Sensitivity', setting: '' },
			{ id: 256, name: 'DMS - Yawning Event Voice Prompt', setting: 'System.Chimes.Yawning' },
			{ id: 339, name: 'DMS - Yawning Minimum Speed', setting: 'Event.Dms.Yawning.SpeedThreshold' },
			{ id: 257, name: 'DMS - Dozing', setting: 'Event.Dms.Dozing.Enabled' },
			{ id: 258, name: 'DMS - Dozing Upload Type', setting: '' },
			{ id: 259, name: 'DMS - Dozing Sensitivity', setting: '' },
			{ id: 260, name: 'DMS - Dozing Event Voice Prompt', setting: 'System.Chimes.Drowsiness' },
			{ id: 340, name: 'DMS - Dozing Minimum Speed', setting: 'Event.Dms.Dozing.SpeedThreshold' },
			{ id: 261, name: 'DMS - Phone Use', setting: 'Event.Dms.PhoneUse.Enabled' },
			{ id: 262, name: 'DMS - Phone Use Upload Type', setting: '' },
			{ id: 263, name: 'DMS - Phone Use Sensitivity', setting: '' },
			{ id: 264, name: 'DMS - Phone Use Voice Prompt', setting: 'System.Chimes.PhoneUse' },
			{ id: 341, name: 'DMS - Phone Use Minimum Speed', setting: 'Event.Dms.PhoneUse.SpeedThreshold' },
			{ id: 265, name: 'DMS - Smoking', setting: 'Event.Dms.Smoking.Enabled' },
			{ id: 266, name: 'DMS - Smoking Upload Type', setting: '' },
			{ id: 267, name: 'DMS - Smoking Sensitivity', setting: '' },
			{ id: 268, name: 'DMS - Smoking Event Voice Prompt', setting: 'System.Chimes.Smoking' },
			{ id: 342, name: 'DMS - Smoking Minimum Speed', setting: 'Event.Dms.Smoking.SpeedThreshold' },
			// {id: 269, name: 'DMS - Seatbelt', setting: 'Event.Dms.Seatbelt.Enabled', isInternal: true},
			{ id: 270, name: 'DMS - Seatbelt', setting: 'Event.Dms.Seatbelt.Enabled' },
			{ id: 271, name: 'DMS - Seatbelt Upload Type', setting: '' },
			{ id: 272, name: 'DMS - Seatbelt Sensitivity', setting: '' },
			{ id: 273, name: 'DMS - Seatbelt Event Audio', setting: 'System.Chimes.Seatbelt' },
			{ id: 343, name: 'DMS - Seatbelt Minimum Speed', setting: 'Event.Dms.Seatbelt.SpeedThreshold' },
			{ id: 274, name: 'Potential Ch2 Obstruction Detection', setting: 'Event.Dms.CameraObstruction.Enabled' },
			{ id: 275, name: 'Potential Ch2 Obstruction Detection Voice Prompt', setting: '' },
			{ id: 276, name: 'Potential Ch2 Obstruction Upload Type', setting: '' },
			{ id: 277, name: 'Potential Ch2 Obstruction Detection Event Audio', setting: 'System.Chimes.CameraObstruction.SoundType' },
			{ id: 344, name: 'Potential Ch2 Obstruction Detection Minimum Speed', setting: 'Event.Dms.CameraObstruction.SpeedThreshold' },
			{ id: 278, name: 'Driver Event', setting: 'Event.PanicButton.Enabled' },
			{ id: 279, name: 'Driver Event Upload Type', setting: '' },
			{ id: 280, name: 'Dangerous Backing-Up Alerts', setting: 'Event.BackUpWarning.Enabled' },
			{ id: 281, name: 'Dangerous Backing-Up Alerts Upload Type', setting: '' },
			{ id: 282, name: 'Dangerous Backing-Up Alerts Event Chime', setting: 'System.Chimes.BackUpWarning', type: 'boolean' },
			{ id: 283, name: 'Harsh Acceleration', setting: 'Event.HarshAccel.Enabled' },
			{ id: 284, name: 'Harsh Acceleration Upload Type', setting: '' },
			// {id: 285, name: 'Harsh Acceleration Sensitivity', setting: 'Event.HarshAccel.Threshold'},
			{ id: 286, name: 'Harsh Acceleration Sensitivity', setting: '' },
			{ id: 287, name: 'Harsh Acceleration Event Audio', setting: 'System.Chimes.HarshAccel' },
			{ id: 288, name: 'Harsh Braking', setting: 'Event.HarshBraking.Enabled' },
			{ id: 289, name: 'Harsh Braking Upload Type', setting: '' },
			// {id: 290, name: 'Harsh Braking Sensitivity', setting: 'Event.HarshBraking.Threshold'},
			{ id: 291, name: 'Harsh Braking Sensitivity', setting: '' },
			{ id: 292, name: 'Harsh Braking Event Audio', setting: 'System.Chimes.HarshBraking' },
			{ id: 293, name: 'High G-Force', setting: 'Event.Accelerometer.Enabled' },
			{ id: 294, name: 'High G-Force Upload Type', setting: '' },
			{ id: 295, name: 'High G-Force Sensitivity', setting: 'Event.Accelerometer.FatalThreshold.X' },
			{ id: 354, name: 'High G-Force Parking Sensitivity', setting: 'Event.Accelerometer.ParkingThreshold.X' },
			{ id: 296, name: 'High G-Force Event Chime', setting: 'System.Chimes.Accelerometer' },
			{ id: 297, name: 'G-Sensor Wake-Up', setting: 'Event.GSensorWakeUp.Enabled' },
			{ id: 298, name: 'G-Sensor Wake-Up Upload Type', setting: '' },
			{ id: 322, name: 'G-Sensor Wake-Up Event Audio', setting: 'System.Chimes.GSensorWakeUp' },
			{ id: 299, name: 'G-Sensor Wake-Up Sensitivity', setting: 'Event.GSensorWakeUp.Sensitivity' },
			{ id: 300, name: 'Max Speed', setting: 'Event.HighSpeed.Enabled' },
			{ id: 301, name: 'Max Speed Upload Type', setting: '' },
			{ id: 302, name: 'Max Speed Threshold', setting: '' },
			{ id: 303, name: 'Max Speed Event Chime', setting: 'System.Chimes.HighSpeed' },
			{ id: 304, name: 'Standard Blind Spot Detection Warning', setting: 'Event.BlindSpotWarning.Standard.Enabled' },
			{ id: 305, name: 'Standard Blind Spot Detection Warning Upload Type', setting: '' },
			{ id: 306, name: 'Standard Blind Spot Detection Warning Event Chime', setting: 'System.Chimes.BlindSpotWarning.Standard', type: 'boolean' },
			{ id: 324, name: 'Standard Blind Spot Detection Warning Minimum Speed', setting: 'Event.BlindSpotWarning.Standard.SpeedThreshold' },
			{ id: 307, name: 'Urban Blind Spot Detection Warning', setting: 'Event.BlindSpotWarning.Urban.Enabled' },
			{ id: 308, name: 'Urban Blind Spot Detection Warning Upload Type', setting: '' },
			{ id: 309, name: 'Urban Blind Spot Detection Warning Event Chime', setting: 'System.Chimes.BlindSpotWarning.Urban', type: 'boolean' },
			{ id: 325, name: 'Urban Blind Spot Detection Warning Minimum Speed', setting: 'Event.BlindSpotWarning.Urban.SpeedThreshold' },
			{ id: 330, name: 'Speed Limit Sign Detection Minimum Speed', setting: 'Event.SpeedLimitViolation.SpeedThreshold' },
			{ id: 310, name: 'Low Speed Limit Sign Detection', setting: 'Event.SpeedLimitViolation.Low.Enabled' },
			{ id: 311, name: 'Low Speed Limit Sign Detection Upload Type', setting: '' },
			{ id: 312, name: 'Low Speed Limit Sign Detection Event Chime', setting: 'System.Chimes.SpeedLimitViolation.Low', type: 'boolean' },
			{ id: 313, name: 'Moderate Speed Limit Sign Detection', setting: 'Event.SpeedLimitViolation.Moderate.Enabled' },
			{ id: 314, name: 'Moderate Speed Limit Sign Detection Upload Type', setting: '' },
			{ id: 315, name: 'Moderate Speed Limit Sign Detection Event Audio', setting: 'System.Chimes.SpeedLimitViolation.Moderate' },
			{ id: 316, name: 'High Speed Limit Sign Detection', setting: 'Event.SpeedLimitViolation.High.Enabled' },
			{ id: 317, name: 'High Speed Limit Sign Detection Upload Type', setting: '' },
			{ id: 318, name: 'High Speed Limit Sign Detection Event Audio', setting: 'System.Chimes.SpeedLimitViolation.High' },
			{ id: 319, name: 'Severe Speed Limit Sign Detection', setting: 'Event.SpeedLimitViolation.Severe.Enabled' },
			{ id: 320, name: 'Severe Speed Limit Sign Detection Upload Type', setting: '' },
			{ id: 321, name: 'Severe Speed Limit Sign Detection Event Audio', setting: 'System.Chimes.SpeedLimitViolation.Severe' },
		],
	},
	dv4: {
		general: [
			{ id: 53, name: 'Camera Event Chime', setting: 'Event.BuzzerEnabled' },
			{ id: 54, name: 'Display Speed on LCD', setting: 'System.DisplaySpeed' },
			{ id: 55, name: 'LCD Backlight Day Mode', setting: 'System.BacklightHigh' },
			{ id: 56, name: 'LCD Backlight Night Mode', setting: 'System.BacklightLow' },
			{ id: 57, name: 'Overlay Speed on Video', setting: 'Overlay.ShowSpeed' },
			{ id: 58, name: 'Parking Duration', setting: 'General.IgnitionShutdownDelay' },
			// {id:144, name: 'Ignition Switch Only', setting: 'General.IgnitionSwitchOnly', type: 'boolean'},
			{ id: 59, name: 'Parking Mode', setting: '' },
			{ id: 60, name: 'Speed Unit', setting: '' },
			{ id: 61, name: 'Timezone', setting: 'General.TimeZone' },
			{ id: 114, name: 'Display Timezone in Video', setting: 'Overlay.ShowTZ', type: 'boolean' },
		],
		video: [
			{ id: 62, name: 'Channel 1', setting: 'Channels.0.Enabled' },
			// {id:63, name: 'Channel 1 Recording', setting: ''},
			{ id: 127, name: 'Channel 1 Recording FPS', setting: 'Channels.0.MainFPS' },
			{ id: 128, name: 'Channel 1 Recording Quality', setting: 'Channels.0.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 129, name: 'Channel 1 Parking Mode FPS', setting: 'Channels.0.ParkingFPS' },
			{ id: 130, name: 'Channel 1 Parking Mode Quality', setting: 'Channels.0.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 64, name: 'Channel 2', setting: 'Channels.1.Enabled' },
			{ id: 65, name: 'Channel 2 Audio', setting: 'Channels.1.Audio', type: 'boolean' },
			// {id:66, name: 'Channel 2 Recording', setting: ''},
			{ id: 131, name: 'Channel 2 Recording FPS', setting: 'Channels.1.MainFPS' },
			{ id: 132, name: 'Channel 2 Recording Quality', setting: 'Channels.1.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 133, name: 'Channel 2 Parking Mode FPS', setting: 'Channels.1.ParkingFPS' },
			{ id: 134, name: 'Channel 2 Parking Mode Quality', setting: 'Channels.1.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 67, name: 'Channel 3', setting: 'Channels.2.Enabled' },
			{ id: 68, name: 'Channel 3 Audio', setting: 'Channels.2.Audio', type: 'boolean' },
			// {id:69, name: 'Channel 3 Recording', setting: ''},
			{ id: 135, name: 'Channel 3 Recording FPS', setting: 'Channels.2.MainFPS' },
			{ id: 136, name: 'Channel 3 Recording Quality', setting: 'Channels.2.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 137, name: 'Channel 3 Parking Mode FPS', setting: 'Channels.2.ParkingFPS' },
			{ id: 138, name: 'Channel 3 Parking Mode Quality', setting: 'Channels.2.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },

			{ id: 70, name: 'Channel 4', setting: 'Channels.3.Enabled' },
			{ id: 71, name: 'Channel 4 Audio', setting: 'Channels.3.Audio', type: 'boolean' },
			// {id:72, name: 'Channel 4 Recording', setting: ''},
			{ id: 139, name: 'Channel 4 Recording FPS', setting: 'Channels.3.MainFPS' },
			{ id: 140, name: 'Channel 4 Recording Quality', setting: 'Channels.3.MainQuality', correctValueFunction: correctValueVideoChannelQuality },
			{ id: 141, name: 'Channel 4 Parking Mode FPS', setting: 'Channels.3.ParkingFPS' },
			{ id: 142, name: 'Channel 4 Parking Mode Quality', setting: 'Channels.3.ParkingQuality', correctValueFunction: correctValueVideoChannelQuality },
		],
		event: [
			{ id: 73, name: 'ADAS - Lane Departure Warning', setting: 'Event.Adas.LaneDeparture.Enabled' },
			{ id: 74, name: 'ADAS- Forward Collision Warning', setting: 'Event.Adas.ForwardCollision.Enabled' },
			{ id: 75, name: 'ADAS - Pedestrian Collision Warning', setting: 'Event.Adas.Pedestrian.Enabled' },
			{ id: 76, name: 'ADAS - Speed Warning Threshold', setting: 'Event.Adas.SpeedThreshold' },
			{ id: 77, name: 'DMS - Distraction', setting: 'Event.Dms.Distraction.Enabled' },
			{ id: 78, name: 'DMS - Distraction Upload Type', setting: '' },
			{ id: 79, name: 'DMS - Drowsiness/Looking Down', setting: 'Event.Dms.Dozing.Enabled' },
			{ id: 80, name: 'DMS - Drowsiness/Looking Down Upload Type', setting: '' },
			{ id: 81, name: 'DMS - Phone Use/Hand to Head', setting: 'Event.Dms.PhoneUse.Enabled' },
			{ id: 82, name: 'DMS - Phone Use/Hand to Head Upload Type', setting: '' },
			{ id: 83, name: 'Driver Event', setting: 'Event.PanicButton.Enabled' },
			{ id: 84, name: 'Driver Event Upload Type', setting: '' },
			{ id: 85, name: 'External Driver Event', setting: 'Event.Sensor.4.Enabled' },
			{ id: 86, name: 'External Driver Event Upload Type', setting: '' },
			{ id: 87, name: 'High G-Force', setting: 'Event.Accelerometer.Enabled' },
			{ id: 88, name: 'High G-Force Upload Type', setting: '' },
			{ id: 89, name: 'High G-Force Sensitivity', setting: 'Event.Accelerometer.FatalThreshold.X' },
			{ id: 90, name: 'Max Speed', setting: 'Event.HighSpeed.Enabled' },
			{ id: 91, name: 'Max Speed Upload Type', setting: '' },
			{ id: 92, name: 'Max Speed Threshold', setting: '' },
		],
	}
}

// Merge default profile settings with newProfile and if absent some keys we add ones to newProfile
export const mergeProfileWithDefault = (defaultProfile, newProfile) => {
	const result = { ...newProfile }

	Object.keys(defaultProfile).forEach((key) => {
		if (typeof defaultProfile[key] === "object" && !Array.isArray(defaultProfile[key])) {
			// If key is object then call function
			result[key] = mergeProfileWithDefault(defaultProfile[key], result[key] || {})
		} else if (!(key in result)) {
			// If key is absend in newProfile, take it from the defaultProfile
			result[key] = defaultProfile[key];
		}
	})

	return result
}

export const channelFPSValidation = (value) => {
	let res = false
	if (value < 1 || value > 30) {
		res = true
	}

	return res
}

export const channelQualityValidation = (value) => {
	let res = false

	if (value < 0 || value > 4) {
		res = true
	}

	return res
}
